import { BASE_PATH } from '../../shared/types';
import { PDF_LIMITS } from '../../shared/pdf/limits';
import { reportingFetch } from './clientErrors';

/** Application fonts. The only PDF inputs cached across registrations; they hold no participant data. */
const fonts = new Map<string, Promise<Uint8Array>>();
function applicationFont(name: string): Promise<Uint8Array> {
  let font = fonts.get(name);
  if (!font) {
    font = (async () => {
      const response = await reportingFetch(`${BASE_PATH}/fonts/${name}`, { cache: 'force-cache', signal: AbortSignal.timeout(30_000) });
      if (!response.ok) throw new Error('Font unavailable');
      const bytes = new Uint8Array(await response.arrayBuffer());
      if (!bytes.length || bytes.length > PDF_LIMITS.fontBytes) throw new Error('Unsupported font');
      return bytes;
    })().catch(error => { fonts.delete(name); throw error; });
    fonts.set(name, font);
  }
  return font;
}
/** The answer font: wide coverage, for answers the handwriting font can't write. */
export const pdfAnswerFont = () => applicationFont('NotoSansSC-Regular.ttf');
/** The handwriting font answers are written in when it has all their characters. */
export const pdfHandFont = () => applicationFont('CampPen-Regular.ttf');
/** The cursive font typed signatures are written in when it has all their characters. */
export const pdfSignatureFont = () => applicationFont('CedarvilleCursive-Regular.ttf');
